export var splitCallbackUrl = function (callbackUrl) {
    var path = 'api/orders/current/payment/direct';
    var prefix = '://';
    var CName = callbackUrl.slice(callbackUrl.indexOf(prefix) + prefix.length, callbackUrl.indexOf(path) - 1);
    return {
        CName: CName,
        path: path,
    };
};
